import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { DrawerParams, PrimeGridOption } from '@grid/abstractions';
import { ModalService } from '@shared/services';

@Component({
  standalone: false,
  selector: 'gstar-grid-crud-buttons',
  templateUrl: './grid-crud-buttons.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridCrudButtonsComponent<TData> {
  private readonly modalService = inject(ModalService);

  @Input() setting?: PrimeGridOption<TData>;
  @Input() data!: TData;

  clickHandler(param: DrawerParams<unknown, unknown>): void {
    this.modalService.open(
      param.component,
      {
        appModalId: 'view-modal',
      },
      { data: this.data }
    );
  }
}
